// extracted by mini-css-extract-plugin
export default {"pd_background":"permission-denied-style_pd_background__7gY0z","pd_foreground":"permission-denied-style_pd_foreground__wbiXl"};